module.exports = __webpack_public_path__ + "img/team-img4.fa14f5d0.jpg";